<script>
	export let data;

	import {
		isNewDataChanged,
		daDataCheck,
	} from "../../../../stores/variables";
	import { request } from "../../../../scripts/request";

	if (data) {
		if (!data.newData) data.newData = [];
		if (!data.newData[data.field_name]) data.newData[data.field_name] = {};
		if (!data.newData[data.field_name].Text)
			data.newData[data.field_name].Text = "";
		if (!data.suggestions) data.suggestions = [];
	}

	let suggestionLength = 5;

	async function fun(raw) {
		let response = await request.DaData(raw, suggestionLength, "daData");
		if (response) {
			data.suggestions = response.suggestions;
			$daDataCheck = true;
		}
	}

	function handleSuggestion(value) {
		data.suggestions = [];
		data.newData[data.field_name].Text = value;
	}
	let isStarted = false;
	let index = 207360000;
</script>

{#if data}
	{#if data.name}
		<h3>{data.name}</h3>
	{/if}

	<div class="inputs">
		<div class="inputs__wrapper">
			<div class="inputs__input input__wrap input__wrap-comment">
				<input
					type="text"
					required={data.required ? "required" : ""}
					on:input={(e) => {
						fun(e.target.value);
						e.target.classList.remove("invalid");
						$isNewDataChanged = true;
					}}
					bind:value={data.newData[data.field_name].Text}
					maxlength={data.maxlength ? data.maxlength : 100}
					on:keypress={(e) => {
						if (e.key == "Enter") {
							e.preventDefault();
						}
					}}
					on:keydown={(e) => {
						let k = e.key;
						if (
							data.suggestions &&
							Array.isArray(data.suggestions) &&
							data.suggestions.length > 0
						) {
							if (k == "ArrowDown") {
								e.preventDefault();
								if (!isStarted) {
									isStarted = true;
									data.suggestions[0].active = true;
								} else {
									index++;
									data.suggestions.forEach((raw) => {
										if (raw.active) raw.active = false;
									});
									data.suggestions[
										index % data.suggestions.length
									].active = true;
								}
								data.suggestions.forEach((suggestion) => {
									if (suggestion.active)
										data.newData[data.field_name].Text =
											suggestion.value;
								});
							}
							if (k == "ArrowUp") {
								e.preventDefault();
								if (!isStarted) {
									isStarted = true;
									data.suggestions[
										data.suggestions.length - 1
									].active = true;
								} else {
									index--;
									data.suggestions.forEach((raw) => {
										if (raw.active) raw.active = false;
									});
									data.suggestions[
										index % data.suggestions.length
									].active = true;
								}
								data.suggestions.forEach((suggestion) => {
									if (suggestion.active)
										data.newData[data.field_name].Text =
											suggestion.value;
								});
							}
							if (k == "Enter") {
								e.preventDefault();
								data.suggestions = [];
								$daDataCheck = false;
								index = 207360000;
							}
							if (k == "Escape") {
								data.suggestions = [];
								$daDataCheck = false;
								index = 207360000;
							}
						}
					}}
				/>
				<span class={data.newData[data.field_name].Text ? "active" : ""}
					>{data.description}</span
				>
			</div>
			{#if data.suggestions}
				<ul class="inputs__suggestions">
					{#each data.suggestions as suggestion}
						<li
							on:click={(e) => {
								handleSuggestion(suggestion.value);
							}}
							class:active={suggestion.active}
						>
							{suggestion.value}
						</li>
					{/each}
				</ul>
			{/if}
		</div>
	</div>
{/if}

<style lang="scss">
	.inputs {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);
		position: relative;

		&__suggestions {
			position: absolute;
			z-index: 1;
			top: 100%;
			background: var(--bg-main-1);
			display: flex;
			flex-direction: column;
			width: 100%;
			box-shadow: 4px 4px 8px 0px #223b4f33;

			> li {
				cursor: pointer;
				display: flex;
				color: var(--bg-black-1);
				font-size: 16px;
				line-height: 24px;
				padding: 9px 16px;
				border-radius: 8px;
				&.active,
				&:hover {
					background-color: #f8f9fe;
				}
			}
		}

		&__wrapper {
			display: flex;
			flex-direction: column;
			margin: 0 0 16px 0;
			position: relative;
			justify-content: center;

			&:last-child {
				margin: 0;
			}
		}

		&__input {
			display: flex;
			flex-direction: column;

			// &-help {
			// 	@media (min-width: 992px) {
			// 		position: absolute;
			// 		right: 16px;

			// 		> div {
			// 			display: none;
			// 		}
			// 	}

			// 	> i {
			// 		display: flex;
			// 		font-size: 18px;
			// 		font-weight: 100;
			// 		color: var(--color-1);

			// 		@media (max-width: 991px) {
			// 			display: none;
			// 		}
			// 	}

			// 	> div {
			// 		color: var(--border-gray);
			// 		font-size: 13px;
			// 		line-height: 20px;
			// 		margin: 6px 0 0 0;
			// 	}
			// }
		}
	}
</style>
